export const GET_LISTS = 'GET_LISTS'
export const GET_LIST = 'GET_LIST'

